import Vue from 'vue';
import Axios from 'axios';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  isBusy: false,
  data: [],
  error: null // status
}

const mutations = {
  SET_OUTLET_PROVIDERS_BUSY: (state, payload) => {
    state.isBusy = payload;
  },
  SET_OUTLET_PROVIDERS_SUCCESS: (state, payload) => {
    state.data = payload;
    state.error = null;
  },
  SET_OUTLET_PROVIDERS_FAIL: (state, payload) => {
    state.data = null;
    state.error = payload;
  }
}

const actions = {
  lookupOutletProviders: ({ commit, state, rootState }) => {

    return new Promise((resolve, reject) => {

      if(state.isBusy) return reject('busy')

      commit('SET_OUTLET_PROVIDERS_BUSY', true);

      const { accessToken } = rootState.user.user.data;

      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      Axios.get(`${API_HOST}/lookups/outlet-providers`, config)
        .then(({ data: { data } }) => {
          commit('SET_OUTLET_PROVIDERS_SUCCESS', data)
          resolve(data)
        })
        .catch(({ response }) => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error') || ''
          });
          commit('SET_OUTLET_PROVIDERS_FAIL', response.status);
          reject(response);
        })
        .finally(() => commit('SET_OUTLET_PROVIDERS_BUSY', false));
    })
  }
};

export default {
  state,
  mutations,
  actions
};